<h2 mat-dialog-title>{{title}}
</h2>
<mat-dialog-content [innerHTML]="content">
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
